<ng-container *ngIf="showCopiedNotice">
    <i class="pi pi-check"></i>
</ng-container>
<ng-container *ngIf="!showCopiedNotice">
    <i class="pi pi-copy" (click)="copy()"></i>
</ng-container>